export default __webpack_public_path__ + "static/envelopeTopOutside-febfae54ffd807d4cb8080ec7db50764.png";